export default
{
	QUEUED: 'queued'
};